import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// actions
import { revenueApiResponseSuccess, revenueApiResponseError } from "./actions";

// constants
import { RevenueActionTypes } from "./constants";
import { getRevenueApi, getRevenueUSDApi } from "../../helpers/api/revenue";

interface RevData {
  payload: {
    type: string;
    path: string;
    from?: string;
    to?: string;
  };
  type: string;
}

function* getRevenues({ payload: { type, path, from, to } }: RevData): SagaIterator {
  

  try {
    let response;
    if (path == "/revenue_usd") {
      
      response = yield call(getRevenueUSDApi, type, from, to);
    } else {
      
      response = yield call(getRevenueApi, type, from, to);
    }

    const categoryData = response?.data;

    

    yield put(revenueApiResponseSuccess(RevenueActionTypes.GET_REVENUE, categoryData));
  } catch (error: any) {
    yield put(revenueApiResponseError(RevenueActionTypes.GET_REVENUE, error));
  }
}

export function* watchGetRevenue() {
  yield takeEvery(RevenueActionTypes.GET_REVENUE, getRevenues);
}

function* revenueSaga() {
  yield all([fork(watchGetRevenue)]);
}

export default revenueSaga;
